import { axiosClient } from '@nx-frontend/shared/api';

export interface CouponsFeaturesRecord {
  couponNumber: Record<string, number>;
}

export interface GetOrgsCouponsFeaturesParams {
  host: string;
  orgId: string;
  userId: number;
}

export async function getOrgsCouponsFeatures(params: GetOrgsCouponsFeaturesParams): Promise<CouponsFeaturesRecord> {
  const { host, orgId, userId } = params;
  let coupons: CouponsFeaturesRecord = {
    couponNumber: {},
  };
  try {
    const response = await axiosClient.get<CouponsFeaturesRecord>(`${host}/v1/orgs/${orgId}/couponsFeatures`, {
      headers: {
        Authorization: `internal ${userId}:auto`,
      },
    });
    coupons = response.data;
  } catch (err) {
    console.error(`can't get coupons for org ${orgId}`);
  }
  return coupons;
}
